import { render, staticRenderFns } from "./MedicationPlansTable.vue?vue&type=template&id=1d901fb1&"
import script from "./MedicationPlansTable.vue?vue&type=script&lang=js&"
export * from "./MedicationPlansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports